import { Box, Container, Typography } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import { Marksome, References } from "react-marksome";
import licenceFile from "../assets/docs/LICENCE.txt";
import type * as CSS from "csstype";

const Footer = () => {
  const { licenceText } = text;
  return (
    <Box sx={styles.rootContainer}>
      <Container disableGutters sx={styles.textContainer}>
        <EmailIcon sx={styles.icon} />
        <Typography sx={styles.text}>oksana.palikova@keskhaigla.ee</Typography>
      </Container>
      <Container disableGutters sx={styles.textContainer}>
        <Typography sx={styles.text}>
          <Marksome text={licenceText} references={references} />
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;

const styles = {
  rootContainer: {
    // This is for making footer sticky with combination of index.css rules
    display: "flex",
    flexDirection: "column",
    flexShrink: 0,
    width: "100%",
    m: "0px",
    p: "0px",
    backgroundColor: "#2D4561",
  },
  textContainer: {
    py: "1vh",
    display: "flex",
    justifyContent: "center",
  },
  text: {
    color: "white !important",
    textAlign: "center",
  },
  icon: {
    color: "white",
  },
  textAndIconWrapper: {
    my: "20px",
    py: "0px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
  },
};

const text = {
  licenceText: "Copyright 2022 [Licence][1]",
};

const link: CSS.Properties = {
  color: "white",
};

const references: References = {
  1: () => (
    <a href={licenceFile} style={link} target="_blank" rel="noreferrer">
      Licence
    </a>
  ),
};
